import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { rootUrl } from "../actions/constants";

const selectTable = state => state.approvalMappings;

export const objectTypeLovSelector = createSelector(
  [selectTable],
  approvalMappings => approvalMappings.objectTypeLov || []
);
export const apmBrowseSelector = createSelector(
  [selectTable],
  approvalMappings => approvalMappings.browse || {}
);

export const fetchObjectTypeLov = createAsyncThunk(
  "rums/personrolelov",
  async (params, { rejectWithValue }) => {
    const { requestType, callback } = params;
    try {
      const response = await makeAjaxRequest.fetchWithAuth(`${rootUrl}/admin/rums/${requestType}/objtypelov`);
      if (callback && typeof callback === "function") {
        callback(response);
      }
      return response?.map((l) => ({ label: l, value: l }));
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
export const fetchAPMData = createAsyncThunk(
  "rums/browse",
  async (callback, { rejectWithValue }) => {
    try {
      const response = await makeAjaxRequest.postWithAuth(`${rootUrl}/admin/rums/approvalmappings/browse`, {});
      if (callback && typeof callback === "function") {
        callback();
      }
      return response;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);

const initialState = {
  objectTypeLov: null,
  browse: {
    data: [],
    loading: false,
    error: null
  }
};

const mappingsSlice = createSlice({
  name: "approvalMappings",
  initialState,
  reducers: {
    resetObjectTypeLov(state) {
      state.objectTypeLov = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAPMData.pending, (state) => {
        state.browse.loading = true;
      })
      .addCase(fetchAPMData.fulfilled, (state, action) => {
        state.browse.loading = false;
        state.browse.data = action.payload.data;
      })
      .addCase(fetchAPMData.rejected, (state, action) => {
        state.browse.loading = false;
        state.browse.error = action.error.message;
      })
      .addCase(fetchObjectTypeLov.fulfilled, (state, action) => {
        state.objectTypeLov = action.payload;
      });
  }
});
export const { resetObjectTypeLov } = mappingsSlice.actions;
export default mappingsSlice.reducer;

export function validateForm(values, existingData, isObjectTypeRequired) {
  const errors = {};

  if (!values.rosterCode) {
    errors.rosterCode = "Roster Code is required.";
  }

  if (!values.requestType) {
    errors.requestType = "Request Type is required.";
  }
  if (!values.recordStatus) {
    errors.recordStatus = "Record Status is required.";
  }
  if (values.approvalRequired === undefined || values.approvalRequired === "") {
    errors.approvalRequired = "Approval Required is required.";
  }
  if (isObjectTypeRequired && !values.objectType) {
    errors.objectType = "Select an Object type from the LOV.";
  }
  const combinationExists = existingData.some(data =>
    data.rosterCode === values.rosterCode &&
    data.requestType === values.requestType &&
    (!isObjectTypeRequired || data.objType === values.objectType)
  );

  if (combinationExists && values.rowOperationType === "insert") {
    errors.rosterCode = "Duplicate RO, Request Type, and Object type exits.";
  }

  return errors;
}
